import { useParamsSearch } from '@anytag/shared-hooks';
import { AssociatedAccountSearchSchemaType } from './schemaTypes';

export const useAssociatedAccountsFilter = () => useParamsSearch<AssociatedAccountSearchSchemaType>();
